export const dataAttr = {
  SIZE: 'data-size',
  SHAPE: 'data-shape',
};

export const sizes = {
  TINY: 'tiny',
  SMALL: 'small',
  LARGE: 'large',
  PORTRAIT: 'portrait',
  CINEMA: 'cinema',
};

export const shapes = {
  CIRCLE: 'circle',
  RECTANGULAR: 'rectangular',
};
